"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDateRows = exports.getParsingDateRules = exports.formatNormalDateObj = exports.formatDateWithTimezone = exports.formatSimpleDateObj = exports.formatOnlyDate = exports.parseDateWithTimezone = exports.parseUtcDateObj = exports.parseUtcToTimestamp = void 0;
var common_1 = require("../../common");
var formatters_1 = require("./formatters");
var datez_1 = __importDefault(require("datez"));
var removeDot = function (date) {
    var indexOfDot = date.indexOf('.');
    if (indexOfDot === -1) {
        return date;
    }
    return date.slice(0, indexOfDot);
};
var addZ = function (date) {
    var indexOfZ = date.indexOf('Z');
    if (indexOfZ !== -1) {
        return date;
    }
    return date + 'Z';
};
var parseUtcToTimestamp = function (utcDate) {
    var result = '';
    for (var i = 0; i < utcDate.length; i += 1) {
        var letter = utcDate[i];
        if (i === utcDate.length - 1 && letter === 'Z') {
            return addZ(removeDot(result));
        }
        if (letter !== ':' && letter !== '-') {
            result += letter;
        }
    }
    result = removeDot(result);
    return result;
};
exports.parseUtcToTimestamp = parseUtcToTimestamp;
var parseUtcDateObj = function (utcDate) {
    return addZ((0, exports.parseUtcToTimestamp)(utcDate.value));
};
exports.parseUtcDateObj = parseUtcDateObj;
var parseDateWithTimezone = function (dateObj) {
    var adjustedDateTimeRaw = datez_1.default.fromISO(dateObj.value, {
        zone: dateObj.timezone,
    });
    if (adjustedDateTimeRaw.invalidReason === 'unsupported zone') {
        throw Error("".concat(adjustedDateTimeRaw === null || adjustedDateTimeRaw === void 0 ? void 0 : adjustedDateTimeRaw.invalidReason, " ").concat(adjustedDateTimeRaw));
    }
    return "TZID=".concat(dateObj.timezone, ":").concat(adjustedDateTimeRaw.toFormat("yyyyMMdd'T'HHmmss"));
};
exports.parseDateWithTimezone = parseDateWithTimezone;
var formatOnlyDate = function (key, value) {
    return (0, formatters_1.foldLine)("".concat((0, formatters_1.transformToICalKey)(key), ";VALUE=DATE:").concat(value)) + '\n';
};
exports.formatOnlyDate = formatOnlyDate;
var formatSimpleDateObj = function (key, value, delimiter) {
    return (0, formatters_1.foldLine)("".concat((0, formatters_1.transformToICalKey)(key)).concat(delimiter).concat((0, exports.parseUtcDateObj)(value))) +
        '\n';
};
exports.formatSimpleDateObj = formatSimpleDateObj;
var formatDateWithTimezone = function (key, value, delimiter) {
    return (0, formatters_1.foldLine)("".concat((0, formatters_1.transformToICalKey)(key)).concat(delimiter).concat((0, exports.parseDateWithTimezone)(value))) + '\n';
};
exports.formatDateWithTimezone = formatDateWithTimezone;
var formatNormalDateObj = function (key, value, delimiter) {
    return (0, formatters_1.foldLine)("".concat((0, formatters_1.transformToICalKey)(key)).concat(delimiter).concat((0, exports.parseUtcToTimestamp)(value))) + '\n';
};
exports.formatNormalDateObj = formatNormalDateObj;
var getParsingDateRules = function (valueAny) {
    var hasTimezone = (valueAny === null || valueAny === void 0 ? void 0 : valueAny.timezone) !== undefined;
    var isSimpleObj = !hasTimezone && (valueAny === null || valueAny === void 0 ? void 0 : valueAny.value) !== undefined;
    var isSimpleDate = !hasTimezone && isSimpleObj && (valueAny === null || valueAny === void 0 ? void 0 : valueAny.value.length) === common_1.DATE_ONLY_LENGTH;
    return {
        hasTimezone: hasTimezone,
        isSimpleDate: isSimpleDate,
        isSimpleObj: isSimpleObj,
    };
};
exports.getParsingDateRules = getParsingDateRules;
/**
 * Parse date row based on different formats
 * @param key
 * @param valueAny
 * @param delimiterPrev
 */
var parseDateRows = function (key, valueAny, delimiterPrev) {
    var _a = (0, exports.getParsingDateRules)(valueAny), hasTimezone = _a.hasTimezone, isSimpleDate = _a.isSimpleDate, isSimpleObj = _a.isSimpleObj;
    var result = '';
    var delimiter = delimiterPrev || ';';
    // Date only for all day events
    if (isSimpleDate) {
        result += (0, exports.formatOnlyDate)(key, valueAny.value);
    }
    else if (isSimpleObj) {
        delimiter = ':';
        result += (0, exports.formatSimpleDateObj)(key, valueAny, delimiter);
    }
    else if (hasTimezone) {
        delimiter = ';';
        // Object with timezone and value
        result += (0, exports.formatDateWithTimezone)(key, valueAny, delimiter);
    }
    else {
        delimiter = ':';
        result += (0, exports.formatNormalDateObj)(key, valueAny, delimiter);
    }
    return result;
};
exports.parseDateRows = parseDateRows;
